import type { ChangelogAdvancedPayload } from "./changelog-advanced.model";

/** Structured changelog for Snoots PMS v1.46.0 (advanced template). */
export const CHANGELOG_ADVANCED_PAYLOAD_V146: ChangelogAdvancedPayload = {
  titleKey: "changelog.advanced.title",
  subtitleKey: "changelog.advanced.subtitle.v146",
  brandKey: "changelog.advanced.brand.pms",
  helpCenterLabelKey: "changelog.advanced.helpCenter",
  helpCenterUrl: "https://helpcenter.snoots.pet/",
  footnoteKey: "changelog.advanced.footer.v146",
  stats: [
    {
      value: 5,
      labelKey: "changelog.advanced.stat.ux",
      accentColor: "#5F5E5A"
    },
    {
      value: 5,
      labelKey: "changelog.advanced.stat.agenda",
      accentColor: "#0F6E56"
    },
    {
      value: 4,
      labelKey: "changelog.advanced.stat.invoicing",
      accentColor: "#BA7517"
    },
    {
      value: 3,
      labelKey: "changelog.advanced.stat.clinica",
      accentColor: "#006288"
    },
    {
      value: 2,
      labelKey: "changelog.advanced.stat.users",
      accentColor: "#185FA5"
    },
    {
      value: 2,
      labelKey: "changelog.advanced.stat.configuration",
      accentColor: "#534AB7"
    },
    {
      value: 23,
      labelKey: "changelog.advanced.stat.fixesRelease",
      accentColor: "#E24B4A"
    }
  ],
  tabs: [
    {
      id: "ux",
      labelKey: "changelog.advanced.tab.ux",
      count: 5,
      sectionLabelKey: "changelog.advanced.section.ux",
      accentColor: "#5F5E5A",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v146.ux.1" },
        { textKey: "changelog.advanced.v146.ux.2" },
        { textKey: "changelog.advanced.v146.ux.3" },
        { textKey: "changelog.advanced.v146.ux.4" },
        { textKey: "changelog.advanced.v146.ux.5" }
      ]
    },
    {
      id: "agenda",
      labelKey: "changelog.advanced.tab.agenda",
      count: 5,
      sectionLabelKey: "changelog.advanced.section.agenda",
      accentColor: "#0F6E56",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v146.agenda.1" },
        { textKey: "changelog.advanced.v146.agenda.2" },
        { textKey: "changelog.advanced.v146.agenda.3" },
        { textKey: "changelog.advanced.v146.agenda.4" },
        { textKey: "changelog.advanced.v146.agenda.5" }
      ]
    },
    {
      id: "fatturazione",
      labelKey: "changelog.advanced.tab.billing",
      count: 4,
      sectionLabelKey: "changelog.advanced.section.billing",
      accentColor: "#BA7517",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v146.billing.1" },
        { textKey: "changelog.advanced.v146.billing.2" },
        { textKey: "changelog.advanced.v146.billing.3" },
        { textKey: "changelog.advanced.v146.billing.4" }
      ]
    },
    {
      id: "clinica",
      labelKey: "changelog.advanced.tab.clinica",
      count: 3,
      sectionLabelKey: "changelog.advanced.section.clinica",
      accentColor: "#006288",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v146.clinica.1" },
        { textKey: "changelog.advanced.v146.clinica.2" },
        { textKey: "changelog.advanced.v146.clinica.3" }
      ]
    },
    {
      id: "utenti",
      labelKey: "changelog.advanced.tab.users",
      count: 2,
      sectionLabelKey: "changelog.advanced.section.users",
      accentColor: "#185FA5",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v146.users.1" },
        { textKey: "changelog.advanced.v146.users.2" }
      ]
    },
    {
      id: "configurazione",
      labelKey: "changelog.advanced.tab.configuration",
      count: 2,
      sectionLabelKey: "changelog.advanced.section.configuration",
      accentColor: "#534AB7",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v146.configuration.1" },
        { textKey: "changelog.advanced.v146.configuration.2" }
      ]
    },
    {
      id: "fix",
      labelKey: "changelog.advanced.tab.fixes",
      count: 23,
      sectionLabelKey: "changelog.advanced.v146.fixes.section",
      accentColor: "#E24B4A",
      kind: "fixes-summary",
      fixesSummaryKey: "changelog.advanced.v146.fixes.summary"
    }
  ]
};
